import { render } from "./CadastrarEtapas.vue?vue&type=template&id=5e79992b"
import script from "./CadastrarEtapas.vue?vue&type=script&lang=js"
export * from "./CadastrarEtapas.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__